// ============================================
// 1. RequireSubscription.jsx
// ============================================
import React from 'react';
import { useSubscription } from '../../context/SubscriptionContext';
import { Gift, ArrowRight } from 'lucide-react';
import { COLORS } from '../../utils/colors';

export default function RequireSubscription({ children }) {
  const { hasActiveSubscription, subscriptionData, loading } = useSubscription();
  
  const enforcementEnabled = subscriptionData?.enforcement_enabled ?? 
    (process.env.REACT_APP_ENFORCE_SUBSCRIPTIONS === 'true');

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!enforcementEnabled) {
    return children;
  }

  if (!hasActiveSubscription) {
    return (
      <div style={{
        padding: '60px 20px',
        maxWidth: '600px',
        margin: '0 auto',
        textAlign: 'center'
      }}>
        <div style={{
          background: `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.secondary} 100%)`,
          color: 'white',
          padding: '40px',
          borderRadius: '12px',
          marginBottom: '20px'
        }}>
          <Gift size={48} style={{ marginBottom: '16px' }} />
          <h2 style={{ margin: '0 0 16px 0', fontSize: '28px' }}>
            Premium Feature
          </h2>
          <p style={{ margin: '0 0 24px 0', fontSize: '16px', opacity: 0.9 }}>
            This feature requires an active subscription. Start your 14-day free trial to get full access.
          </p>
          <a
            href="/settings/billing"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: COLORS.white,
              color: COLORS.primary,
              padding: '14px 32px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '16px'
            }}
          >
            Start Free Trial <ArrowRight size={18} />
          </a>
        </div>
        <a href="/home" style={{ color: COLORS.primary, textDecoration: 'none' }}>
          ← Back to Home
        </a>
      </div>
    );
  }

  return children;
}